import Enquires from './Enquires';
import AuthRole from 'layouts/Dashboard/AuthRole';

const routes = [

  { path: 'enquires', element: <AuthRole role="administrator" isPage><Enquires /></AuthRole>},
]

  export default routes;